/**
 * API client to query the java server.
 */
import axios from "axios";

export default class ApiClient {
  constructor(baseUrl) {
    this.http = axios.create({
      baseURL: baseUrl
    });
  }

  // -------------------------------------------------
  // PORTFOLIO API
  // -------------------------------------------------

  /**
   * Get a trade for the given member and ID
   */
  async getTradeById(tradeId) {
    const url = `/api/portfolio/${tradeId}`;
    let resp = await this.http.get(url);
    return resp.data;
  }

  async getTrades(page, number) {
    let url = `/api/portfolio`;

    if (page !== undefined) {
      let nb = number || 20;
      url += `&page=${page}&nb=${nb}`;
    }
    let resp = await this.http.get(url);
    return resp.data;
  }

  async getTradesForMember(member, page, number) {
    let url = `/api/portfolio?member=${member}`;
    if (page !== undefined) {
      let nb = number || 20;
      url += `&page=${page}&nb=${nb}`;
    }
    let resp = await this.http.get(url);
    return resp.data;
  }

  async getMembers() {
    let resp = await this.http.get("/api/portfolio/member");
    return resp.data;
  }
  // ----------------------------------------------------
  // CURVE API
  // ----------------------------------------------------

  /**
   * Will return the current curves being used in the pricing environment
   */
  async getCurveNames() {
    let resp = await this.http.get("/api/curve");
    return resp.data;
  }

  /**
   * Return a list of curves.
   * [Curve{
      name	string
      xs	[...]
      ys	[...]
      extrapolatorLeft	string
      extrapolatorRight	string
      interpolator	string
    }]
   * @param {String} curveName The curve you want to load.
   */
  async getCurve(curveName) {
    const url = `/api/curveByName?names=${curveName}`;
    const resp = await this.http.get(url);
    return resp.data;
  }

  // ------------------------------------------------------
  // RISK API
  // ---------------------------------------------------------

  /**
   * Will return all the risk nodes (information)
   * */
  async getRiskNodes() {
    let resp = await this.http.get("/api/risk/node");
    return resp.data;
  }

  /**
   * return scenario metadata.
   */
  async getScenarioInfo() {
    let resp = await this.http.get("/api/risk/scenario");
    return resp.data;
  }

  /**
   * Return the risk results for the given node. Cached by server.
   *
   * @param {NodeInformation} nodeInfo
   */
  async computeRisk(nodeInfo) {
    const url = "/api/risk/compute";
    const resp = await this.http.post(url, nodeInfo);
    return resp.data;
  }

  /**
   *
   * @param {StereotypeData} tradeData Not the complete trade. Just enough to recreate in Strata.
   */
  async priceTrade(tradeData) {
    const url = "/api/risk/price";
    let resp = await this.http.post(url, tradeData);
    return resp.data;
  }

  async runSimulation(nodeInfo, trades) {
    const url = "/api/risk/simulation";
    let payload = { trades: trades };
    if (nodeInfo != null) {
      payload.nodeInfo = nodeInfo;
    }
    let resp = await this.http.post(url, payload);
    return resp.data;
  }

  async parseFpML(file) {
    const url = "/api/fileparse";
    let payload = new FormData();
    payload.append("file", file);
    let resp = await this.http.post(url, payload);
    return resp.data;
  }
}
